<!-- 데스크톱 레이아웃 -->
<main class="hidden lg:flex flex-col gap-6 container mx-auto pt-30 pb-15 px-4">
  <div class="flex flex-col gap-6">
    <h1 class="text-2xl text-zinc-800 text-center">밀리언쇼 참가신청</h1>
    <div class="max-w-200 w-full mx-auto flex flex-col gap-6">
      <!-- 폼 컨텐츠 -->
      <div class="border border-zinc-200 rounded-lg bg-white">
        <!-- 데스크톱 스텝 인디케이터 -->
        <div class="hidden! lg:block!">
          <app-step-indicator class="px-6 py-3" [steps]="steps" [currentStep]="currentStep()" />
          <div class="w-full h-px bg-zinc-100"></div>
        </div>

        <div class="p-6">
          <!-- 1단계: 참가신청 정보 -->
          @if (currentStep() === 'info') {
          <app-booth-info [form]="form" [events]="events()" />
          }

          <!-- 2단계: 업체 정보 -->
          @if (currentStep() === 'company') {
          <app-booth-company [form]="form" [uploadHandler]="uploadHandler" [deleteHandler]="deleteHandler" />
          }

          <!-- 3단계: 부스/부대시설 선택 -->
          @if (currentStep() === 'options') {
          <app-booth-options
            [boothOptionsArray]="boothOptionsArray"
            [isLoading]="$availableTemplates.isLoading()"
            [event]="event()" />
          }
        </div>
      </div>

      <!-- 약관 동의 (3단계일 때만) -->
      @if (currentStep() === 'options') {
      <app-terms-agreement
        [allAgreed]="allAgreed()"
        (allAgreedChange)="toggleAllAgreed($event)"
        [(isTermsAgreed)]="isTermsAgreed"
        [(isPrivacyAgreed)]="isPrivacyAgreed"
        (openPolicy)="openPolicyModal($event)" />
      }

      <!-- 하단 버튼 -->
      <app-booth-action-buttons
        [currentStep]="currentStep()"
        [isStepValid]="isStepValid(currentStep())"
        [canSubmit]="canSubmit()"
        (prevStep)="prevStep()"
        (nextStep)="nextStep()"
        (submitForm)="submit()" />
    </div>
  </div>
</main>

<!-- 모바일 레이아웃 -->
<app-page-modal-container class="lg:hidden">
  <main class="pb-20">
    <app-step-indicator class="p-4" [steps]="steps" [currentStep]="currentStep()" />
    <div class="w-full h-px bg-zinc-100"></div>

    <div class="flex flex-col gap-6 p-4">
      <!-- 폼 컨텐츠 -->
      <div class="border border-zinc-200 rounded-lg bg-white p-6">
        <!-- 1단계: 참가신청 정보 -->
        @if (currentStep() === 'info') {
        <app-booth-info [form]="form" [events]="events()" />
        }

        <!-- 2단계: 업체 정보 -->
        @if (currentStep() === 'company') {
        <app-booth-company [form]="form" [uploadHandler]="uploadHandler" [deleteHandler]="deleteHandler" />
        }

        <!-- 3단계: 부스/부대시설 선택 -->
        @if (currentStep() === 'options') {
        <app-booth-options
          [boothOptionsArray]="boothOptionsArray"
          [isLoading]="$availableTemplates.isLoading()"
          [event]="event()" />
        }
      </div>

      <!-- 약관 동의 (3단계일 때만) -->
      @if (currentStep() === 'options') {
      <app-terms-agreement
        [allAgreed]="allAgreed()"
        (allAgreedChange)="toggleAllAgreed($event)"
        [(isTermsAgreed)]="isTermsAgreed"
        [(isPrivacyAgreed)]="isPrivacyAgreed"
        (openPolicy)="openPolicyModal($event)" />
      }
    </div>
  </main>

  <!-- 모바일 하단 고정 버튼 -->
  <div class="flex gap-3 p-4" footer>
    <app-booth-action-buttons
      [currentStep]="currentStep()"
      [isStepValid]="isStepValid(currentStep())"
      [canSubmit]="canSubmit()"
      (prevStep)="prevStep()"
      (nextStep)="nextStep()"
      (submitForm)="submit()" />
  </div>
</app-page-modal-container>
